export const MANDATORY_DISCLOSURE_LINK =
  "https://sites.google.com/stmichaels-school.in/mandatorydisclosure/home";
